module.exports = __webpack_public_path__ + "static/img/posm.a0ed246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT002/posm.png
// module id = UTrB
// module chunks = 1